import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M16 3.52l9.92 9.34V28H6V12.93l10-9.41M16 26a7 7 0 10-7-7 7 7 0 007 7m0-24.5a2 2 0 00-1.2.4L4.71 11.4A2 2 0 004 12.93V28a2 2 0 002 2h20a2 2 0 002-2V12.93a2 2 0 00-.71-1.53L17.2 1.9a2 2 0 00-1.2-.4zM16 24a5 5 0 115-5 5 5 0 01-5 5z"/><path d="M18.89 20.45A1 1 0 0118 21a.93.93 0 01-.45-.11L15 19.62V17a1 1 0 012 0v1.38l1.45.73a1 1 0 01.44 1.34z"/>';
export var HouseTimeOutlineSVG = function HouseTimeOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
HouseTimeOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(HouseTimeOutlineSVG);